export default __webpack_public_path__ + "89fe85b3fad51e73215238d23df2d20b.png";